var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from 'react';
import { getAPIErrorData } from '../utils/returns/returns-helper';
var useFetchState = function () {
    var _a = useState(null), data = _a[0], setData = _a[1];
    var _b = useState(false), isFetched = _b[0], setIsFetched = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useState(null), error = _d[0], setError = _d[1];
    var _e = useState(null), errorMsg = _e[0], setErrorMsg = _e[1];
    var fetchData = function (fetchFunction) { return __awaiter(void 0, void 0, void 0, function () {
        var result, err_1, errorData, tempError;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    result = null;
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, fetchFunction()];
                case 2:
                    result = _a.sent();
                    setData(result);
                    setError(null);
                    setErrorMsg(null);
                    return [2 /*return*/, { data: result, error: null }];
                case 3:
                    err_1 = _a.sent();
                    setData(null);
                    // Check (loosely) if it's an AxiosError
                    if ('response' in err_1) {
                        errorData = getAPIErrorData(err_1);
                        if (!errorData) {
                            tempError = new Error('No error data found');
                            setError(tempError);
                            setErrorMsg('No error data found');
                            return [2 /*return*/, { data: null, error: tempError }];
                        }
                        setError(errorData);
                        setErrorMsg(errorData === null || errorData === void 0 ? void 0 : errorData.description);
                        return [2 /*return*/, { data: null, error: errorData }];
                    }
                    if (err_1 instanceof Error) {
                        setError(err_1);
                        setErrorMsg(err_1.message);
                        return [2 /*return*/, { data: null, error: err_1 }];
                    }
                    return [2 /*return*/, { data: null, error: err_1 }];
                case 4:
                    setLoading(false);
                    setIsFetched(true);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return {
        data: data,
        loading: loading,
        error: error,
        errorMsg: errorMsg,
        isFetched: isFetched,
        fetchData: fetchData,
    };
};
export default useFetchState;
